"use strict";

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.match");

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.array.some");

require("core-js/modules/es6.object.define-property");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var variables_1 = require("./variables");

var lightTheme_1 = require("./theming/lightTheme");

var isEmpty_1 = __importDefault(require("lodash/isEmpty"));

var get_1 = __importDefault(require("lodash/get"));

exports.matchesMedia = function (breakpoints) {
  // tslint:disable-next-line:no-parameter-reassignment
  breakpoints = breakpoints || [];
  return breakpoints.some(function (bp) {
    return window.matchMedia(variables_1.bpMediaQueries[bp]).matches;
  });
}; // tslint:disable-next-line:variable-name


var GetIEVersion = function GetIEVersion(Idx, sAgent) {
  // If IE, return version number.
  if (Idx > 0) {
    return parseInt(sAgent.substring(Idx + 5, sAgent.indexOf(".", Idx)), 10);
  } // If IE 11 then look for Updated user agent string.
  // tslint:disable-next-line:no-else-after-return
  else if (!!navigator.userAgent.match(/Trident\/7\./)) return 11; // tslint:disable-next-line:comment-format
    else return 0; //It is not IE

}; // We keep this here such that the UI component lib has no hard dependency on the service lib


exports.checkForIE11 = function (shouldConsoleLog) {
  if (shouldConsoleLog === void 0) {
    shouldConsoleLog = false;
  } // tslint:disable-next-line:no-parameter-reassignment


  shouldConsoleLog = shouldConsoleLog || false;
  var sAgent = window.navigator.userAgent; // tslint:disable-next-line:variable-name

  var Idx = sAgent.indexOf("MSIE");
  shouldConsoleLog === true && console.log("Is this internet explorer?", GetIEVersion(Idx, sAgent) > 1);
  return GetIEVersion(Idx, sAgent) > 1;
};
/**
 *
 * @param theme will default to lightTheme when empty
 * @param path using dot notation
 * @returns {*}
 */


function themeProp(theme, path) {
  // tslint:disable-next-line:no-parameter-reassignment
  theme = isEmpty_1["default"](theme) ? lightTheme_1.lightTheme : theme;
  var value = get_1["default"](theme, path);

  if (value === undefined) {
    console.error("Theme property not found: " + path);
    return "tomato";
  }

  return value;
}

exports.themeProp = themeProp;
/**
 * @param path using dot notation
 * @returns {function(Object): *}
 */

function theme(path) {
  return function (_a) {
    var theme = _a.theme;
    return themeProp(theme, path);
  };
}

exports.theme = theme;
/**
 * Will traverse deeply through the given object and prefix all property values with the given
 * prefix which match the given propKey.
 * @param object
 * @param propKey
 * @param prefix
 */

function prependToProp(object, propKey, prefix) {
  Object.keys(object).forEach(function (key) {
    if (typeof object[key] === "object") {
      prependToProp(object[key], propKey, prefix);
    } else if (key === propKey) {
      object[key] = prefix + "/" + object[key];
    }
  });
}

exports.prependToProp = prependToProp;
/**
 * Check if the current object key value represents an image
 * i.e. it should be an object containing a src prop, in that case, add customRoot to it
 * @param object
 * @param customRoot
 */

function addCustomRoot(themedImages, customRoot) {
  Object.keys(themedImages).forEach(function (key) {
    var item = themedImages[key];
    var itemIsObject = typeof item === "object";

    if (itemIsObject && item.src) {
      themedImages[key].customRoot = customRoot;
    } else if (itemIsObject) {
      addCustomRoot(item, customRoot);
    }
  });
}

exports.addCustomRoot = addCustomRoot;